var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_12454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.95 12.5H14.1667C13.7246 12.5 13.3007 12.6756 12.9882 12.9882C12.6756 13.3007 12.5 13.7246 12.5 14.1667V17.95",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 2.78333V4.16666C5.8335 4.8297 6.09689 5.46558 6.56573 5.93443C7.03457 6.40327 7.67045 6.66666 8.3335 6.66666C8.77552 6.66666 9.19945 6.84225 9.51201 7.15481C9.82457 7.46737 10.0002 7.8913 10.0002 8.33332C10.0002 9.24999 10.7502 9.99999 11.6668 9.99999C12.1089 9.99999 12.5328 9.8244 12.8453 9.51184C13.1579 9.19928 13.3335 8.77535 13.3335 8.33332C13.3335 7.41666 14.0835 6.66666 15.0002 6.66666H17.6418",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 18.2917V15C9.16683 14.558 8.99123 14.1341 8.67867 13.8215C8.36611 13.5089 7.94219 13.3334 7.50016 13.3334C7.05813 13.3334 6.63421 13.1578 6.32165 12.8452C6.00909 12.5326 5.8335 12.1087 5.8335 11.6667V10.8334C5.8335 10.3913 5.6579 9.9674 5.34534 9.65484C5.03278 9.34228 4.60886 9.16669 4.16683 9.16669H1.7085",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3334C14.6022 18.3334 18.3332 14.6024 18.3332 10C18.3332 5.39765 14.6022 1.66669 9.99984 1.66669C5.39746 1.66669 1.6665 5.39765 1.6665 10C1.6665 14.6024 5.39746 18.3334 9.99984 18.3334Z",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_12454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldLog);
export default __webpack_public_path__ + "static/media/world-log.63f497d157787561baf602dc9a2f6745.svg";
export { ForwardRef as ReactComponent };